import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { PreloadAllModules, provideRouter, withHashLocation, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CommonLibModule } from './lib/common-lib.module';
import { provideNativeDateAdapter } from '@angular/material/core';
import { HttpInterceptorService } from './lib/services/http-interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { getHostUrl } from './config/host-url.config';
import { AutoSelectSingleGlobalDirective } from './shared/auto-select-single.directive';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', floatLabel: 'always' } },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    importProvidersFrom([
      CommonLibModule.forRoot({
        //hostUrl: 'https://ncmstest.westeurope.cloudapp.azure.com/ccms-azt/web/api/',
        // azl 
        hostUrl: getHostUrl(environment.deploymentEnv),
        //'https://ncmstest.westeurope.cloudapp.azure.com/web/api/', 
        // hostUrl: 'http://localhost:8082/ccms/web/api/',
        // hostUrl: 'https://ncmstest.westeurope.cloudapp.azure.com/ccms-azt/web/api/',
        //hostUrl: 'http://localhost:8082/ccms/web/api/',
        courtId: '4',
        userId: 'BOH99207',
        isProd: environment.production
      }),
      AutoSelectSingleGlobalDirective
    ]),
    FormsModule,
    ReactiveFormsModule,
    // ✅ Register Angular Service Worker here

  ],
};
